var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("g", { attrs: { "clip-path": "url(#" + _vm.clipId + ")" } }, [
        _c("path", {
          attrs: {
            d:
              "M14.095 6H9.905C8.085 6 7 7.085 7 8.905V13.09C7 14.915 8.085 16 9.905 16H14.09C15.91 16 16.995 14.915 16.995 13.095V8.905C17 7.085 15.915 6 14.095 6ZM14.205 9.915C13.9 10.785 13.08 11.37 12.16 11.37H11.12C11.12 11.37 11.12 11.365 11.115 11.365C10.735 11.365 10.405 11.62 10.305 11.985C10.75 12.125 11.075 12.54 11.075 13.03C11.075 13.635 10.58 14.13 9.975 14.13C9.37 14.13 8.875 13.635 8.875 13.03C8.875 12.585 9.145 12.2 9.525 12.03V9.85C9.145 9.7 8.875 9.33 8.875 8.9C8.875 8.335 9.335 7.875 9.9 7.875C10.465 7.875 10.925 8.335 10.925 8.9C10.925 9.335 10.655 9.7 10.275 9.85V10.86C10.52 10.705 10.81 10.615 11.115 10.615H12.15C12.74 10.64 13.265 10.26 13.475 9.71C13.23 9.52 13.07 9.23 13.07 8.9C13.07 8.335 13.53 7.875 14.095 7.875C14.66 7.875 15.12 8.335 15.12 8.9C15.125 9.43 14.72 9.86 14.205 9.915Z",
            fill: _vm.colorInternal
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: _vm.clipId } }, [
          _c("rect", {
            attrs: {
              width: "9.995",
              height: "10",
              fill: _vm.colorInternal,
              transform: "translate(7 6)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }